import React, { useEffect, useRef } from 'react';
import Chart from 'chart.js/auto';

function PricingCharts() {
  const pricingChartRef = useRef(null);
  const pricingChartInstance = useRef(null);

  useEffect(() => {
    initializeCharts();
    
    return () => {
      if (pricingChartInstance.current) {
        pricingChartInstance.current.destroy();
      }
    };
  }, []);

  const initializeCharts = () => {
    const palette = {
      primary: '#4F46E5',
      secondary: '#EC4899',
      accent: '#10B981',
      neutral: '#6B7280',
    };

    if (pricingChartRef.current) {
      const pricingCtx = pricingChartRef.current.getContext('2d');
      pricingChartInstance.current = new Chart(pricingCtx, {
        type: 'bar',
        data: {
          labels: ['Remote-Assistant.ai', 'Acuity Scheduling', 'Smith.ai (Starter)', 'Goodcall (Growth)'],
          datasets: [{
            label: 'Estimated Monthly Cost ($USD)',
            data: [100, 16, 95, 99],
            backgroundColor: [palette.primary, palette.accent, palette.secondary, palette.neutral],
            borderColor: [palette.primary, palette.accent, palette.secondary, palette.neutral],
            borderWidth: 1,
            borderRadius: 8
          }]
        },
        options: {
          maintainAspectRatio: false,
          responsive: true,
          scales: {
            y: {
              beginAtZero: true,
              title: {
                display: true,
                text: 'Monthly Cost ($)',
                font: { size: 14 }
              }
            }
          },
          plugins: {
            legend: {
              display: false
            }
          }
        }
      });
    }


  };

  return (
    <div className="flex justify-center mt-20">
      <div className="bg-white rounded-xl shadow-lg p-6 md:p-8 max-w-2xl w-full">
        <h3 className="text-3xl font-bold text-center mb-2">The Price of Power</h3>
        <p className="text-center text-gray-600 mb-6">Comparing monthly costs for core SMB plans.</p>
        <div className="relative w-full h-80">
          <canvas ref={pricingChartRef}></canvas>
        </div>
        <div className="mt-6 text-center text-gray-700">
          <p className="font-semibold">Remote-Assistant.ai offers a unique value proposition.</p>
          <p>Our model pays for itself. The booking deposits you collect directly offset your monthly fee, making our powerful AI incredibly cost-effective.</p>
        </div>
      </div>
    </div>
  );
}

export default PricingCharts;